import React, { useEffect, useMemo, useState } from 'react';
import styled from '@emotion/styled';
import baselogo from '../../../assets/baselogo.svg';
const Bar = styled.div`
  width: 100%;
  box-sizing: border-box;
  min-height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px 16px;
  color: #fff;
  background:
    radial-gradient(circle at 50% 0%, rgba(0, 82, 255, 0.25), transparent 42%),
    linear-gradient(90deg, #202020 0%, #060606 45%, #1c1b1b 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);

  @media (max-width: 480px) {
    padding: 7px 8px;
  }
`;

const Inner = styled.div`
  width: min(1180px, 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: nowrap;
  text-align: center;

  @media (max-width: 480px) {
    gap: 7px;
    flex-wrap: wrap;
  }
`;

const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;

  @media (max-width: 480px) {
    flex-shrink: 1;
    gap: 6px;
    min-width: 0;
  }
`;

const Logo = styled.img`
  width: 100%;
  max-width: 70px;
  height: auto;
  object-fit: contain;

  @media (max-width: 480px) {
    max-width: 82px;
  }
`;

const Label = styled.span`
  font-family: Bold;
  font-size: 15px;
  line-height: 1.2;
  color: #ffffff;
  white-space: nowrap;

  span {
    color: #8fb1ff;
  }

  @media (max-width: 480px) {
    font-size: 11px;
  }

  @media (max-width: 360px) {
    font-size: 10px;
  }
`;

const Timer = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  flex-shrink: 1;
  min-width: 0;

  @media (max-width: 480px) {
    gap: 5px;
    width: 100%;
    justify-content: center;
  }

  @media (max-width: 360px) {
    gap: 3px;
  }
`;

const TimePill = styled.span`
  min-width: 51px;
  padding: 4px 9px;
  border-radius: 999px;
  background: #272727;
  border: 1px solid rgba(255, 255, 255, 0.28);
  font-family: Bold;
  font-size: 13px;
  line-height: 1;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);

  @media (max-width: 480px) {
    min-width: 0;
    width: clamp(34px, 20vw, 40px);
    padding: 4px 4px;
    font-size: 11px;
  }

  @media (max-width: 360px) {
    width: clamp(30px, 20vw, 34px);
    padding: 4px 3px;
    font-size: 10px;
  }
`;

const Unit = styled.span`
  opacity: 0.78;
  font-family: PoppinsM;
  font-size: 10px;
  margin-left: 3px;

  @media (max-width: 480px) {
    font-size: 8px;
    margin-left: 2px;
  }
`;
const LogoSvg = styled.svg`
  width: 80px;
  height: auto;
  display: block;
   @media (max-width: 600px) {
      width: 50px;
  }

  @media (max-width: 360px) {
      width: 44px;
  }
`;
const getTimeLeft = (targetDate) => {
  const difference = targetDate.getTime() - Date.now();

  if (difference <= 0) {
    return null;
  }

  const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((difference / (1000 * 60)) % 60);
  const seconds = Math.floor((difference / 1000) % 60);

  return { days, hours, minutes, seconds };
};

const formatNumber = (value) => String(value).padStart(2, '0');

const LaunchBar = () => {
  const targetDate = useMemo(() => new Date('2026-05-20T15:00:00Z'), []);
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(targetDate));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft(targetDate));
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <Bar>
      <Inner>
        <Brand>
       
          <Label>Shadow Node launching on</Label>
            <LogoSvg
              width="351"
              height="90"
              viewBox="0 0 351 90"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M122.604 89.6974C115.697 89.6974 109.041 87.1857 105.148 80.5299H102.887V87.8137H87.1895V1.16162H102.887V32.6829H105.148C109.166 25.7758 116.701 23.1386 123.483 23.1386C140.436 23.1386 151.865 36.7015 151.865 55.7901C151.865 75.2554 139.306 89.6974 122.604 89.6974ZM119.213 75.6321C128.883 75.6321 135.79 67.7204 135.79 56.418C135.79 45.1156 128.757 37.2038 119.213 37.2038C109.794 37.2038 102.887 44.7388 102.887 56.418C102.887 68.0972 109.794 75.6321 119.213 75.6321ZM180.874 89.6974C168.818 89.6974 159.023 82.4136 159.023 70.4833C159.023 56.418 169.823 51.897 182.883 50.5156L201.344 48.6319V45.1156C201.344 39.7155 196.949 35.948 189.163 35.948C181.753 35.948 177.483 39.2132 176.102 44.1109H161.032C162.539 32.1805 172.46 23.1386 189.163 23.1386C205.237 23.1386 215.912 30.9247 215.912 46.1202V76.7624C215.912 80.6555 216.288 86.0555 216.54 87.5625V87.8137H201.47C201.344 85.6788 201.344 83.6694 201.344 81.5345H199.084C195.191 87.8137 188.409 89.6974 180.874 89.6974ZM185.144 77.8926C195.442 77.8926 201.344 70.1065 201.344 62.1948V59.0552L187.53 60.6878C178.99 61.6925 174.846 64.2041 174.846 69.7298C174.846 74.8786 179.116 77.8926 185.144 77.8926ZM253.586 89.6974C237.763 89.6974 226.461 81.7857 224.702 69.353H240.149C241.907 74.8786 247.684 77.2647 253.712 77.2647C259.866 77.2647 264.889 74.6275 264.889 69.9809C264.889 65.3344 260.117 64.0785 253.586 62.9483L246.931 61.8181C234.372 59.6831 226.586 54.4087 226.586 43.1062C226.586 30.7991 237.386 23.1386 252.331 23.1386C266.898 23.1386 276.568 29.9201 279.205 41.7248H264.135C262.377 37.0783 257.731 35.1945 252.456 35.1945C246.051 35.1945 241.907 37.9573 241.907 41.8504C241.907 45.8691 245.172 47.1249 251.954 48.2551L258.61 49.3854C270.791 51.3947 280.084 56.418 280.084 68.5995C280.084 81.9113 269.033 89.6974 253.586 89.6974ZM319.392 89.6974C300.052 89.6974 287.243 76.5112 287.243 56.2924C287.243 36.4504 300.806 23.1386 319.517 23.1386C339.108 23.1386 350.411 37.7062 350.411 56.9203V59.6831H302.564C303.317 70.1065 310.601 76.2601 319.392 76.2601C326.676 76.2601 331.071 73.7484 333.206 69.353H349.28C346.015 81.1578 334.336 89.6974 319.392 89.6974ZM335.09 49.2598C333.834 40.8457 327.178 35.948 319.392 35.948C311.229 35.948 304.322 40.7202 302.815 49.2598H335.09Z"
                fill="#ffffff"
              />
              <path
                d="M4.02139 87.8138C1.50973 87.8138 0.253906 86.558 0.253906 84.0463V28.7899C0.253906 26.2783 1.50973 25.0225 4.02139 25.0225H59.2778C61.7894 25.0225 63.0452 26.2783 63.0452 28.7899V84.0463C63.0452 86.558 61.7894 87.8138 59.2778 87.8138H4.02139Z"
                fill="#0000FF"
              />
            </LogoSvg>
        </Brand>
        {timeLeft && (
          <Timer>
            <TimePill>{formatNumber(timeLeft.days)}<Unit>D</Unit></TimePill>
            <TimePill>{formatNumber(timeLeft.hours)}<Unit>H</Unit></TimePill>
            <TimePill>{formatNumber(timeLeft.minutes)}<Unit>M</Unit></TimePill>
            <TimePill>{formatNumber(timeLeft.seconds)}<Unit>S</Unit></TimePill>
          </Timer>
        )}
      </Inner>
    </Bar>
  );
};

export default LaunchBar;
